import {formatToCurrencyType} from "helper/common";
import {FIELD_TYPE} from "types/enums";
import {ColumnsEdit} from "types/models/column-table-edit";
import {DataFormField} from "types/models/input-field-type";

const {INPUT, COMBO_BOX, DATE_DISABLE, SELECT} = FIELD_TYPE;

const revenuesFields: DataFormField[] = [
  // {
  //   label: "Loại",
  //   type: SELECT,
  //   name: "idNhomDichVu",
  //   options: [
  //     {label: "Khám mắt", value: 1},
  //     {
  //       label: "Phẫu thuật",
  //       value: 2,
  //     },
  //   ],
  // },
  {
    label: "Tên dịch vụ",
    type: COMBO_BOX,
    name: "maDichVu",
  },
  {
    label: "Mã BN",
    type: INPUT,
    name: "maBenhNhan",
  },
  {
    label: "Tên BN",
    type: INPUT,
    name: "tenBenhNhan",
  },
  {
    label: "Thời gian từ",
    type: DATE_DISABLE,
    name: "start",
  },
  {
    label: "Thời gian đến",
    type: DATE_DISABLE,
    name: "end",
  },
];

const surgeryAllColums: ColumnsEdit = [
  {
    title: "STT",
    key: "stt",
    dataIndex: "stt",
    fixed: "left",
    width: 70,
    align: "center",
  },
  {
    title: "Thời gian",
    key: "thoiGian",
    dataIndex: "thoiGian",
    align: "left",
    width: 120,
  },
  {
    title: "Mã BN",
    key: "maBenhNhan",
    dataIndex: "maBenhNhan",
    align: "left",
    width: 70,
  },
  {
    title: "Họ tên",
    key: "tenBenhNhan",
    dataIndex: "tenBenhNhan",
    align: "left",
    width: 130,
  },
  {
    title: "Giới tính",
    key: "gioiTinh",
    dataIndex: "gioiTinh",
    align: "left",
    width: 80,
  },
  {
    title: "Tên dịch vụ",
    key: "dichVu",
    dataIndex: "dichVu",

    width: 180,
  },
  {
    title: "Loại Item",
    key: "loaiItem",
    dataIndex: "loaiItem",
    width: 100,
  },
  {
    title: "Doanh thu",
    key: "doanhThu",
    dataIndex: "doanhThu",
    render: text => formatToCurrencyType(text),
    align: "right",
    width: 70,
  },
  {
    title: "BHYT chi trả",
    key: "baoHiemChiTra",
    dataIndex: "baoHiemChiTra",
    disabledCheck: true,
    width: 70,
    render: text => formatToCurrencyType(text),
    align: "right",
  },
  {
    title: "BN cùng chi trả",
    key: "bnCungChiTra",
    dataIndex: "bnCungChiTra",
    disabledCheck: true,
    width: 70,
    render: text => formatToCurrencyType(text),
    align: "right",
  },
  {
    title: "BN tự trả",
    key: "bnTuTra",
    dataIndex: "bnTuTra",
    disabledCheck: true,
    width: 70,
    render: text => formatToCurrencyType(text),
    align: "right",
  },
  {
    title: "Tổng miễn giảm",
    key: "tongMienGiam",
    dataIndex: "tongMienGiam",
    width: 80,
    align: "right",
    render: text => formatToCurrencyType(text),
  },
  {
    title: "Doanh thu sau miễn giảm",
    key: "doanhThuSauMienGiam",
    dataIndex: "doanhThuSauMienGiam",
    render: text => formatToCurrencyType(text),
    align: "right",
    width: 80,
  },
  {
    title: "Tạm ứng",
    key: "tamUng",
    dataIndex: "tamUng",
    render: text => formatToCurrencyType(text),
    align: "right",
    width: 80,
  },
  {
    title: "BN phải trả",
    key: "bnChiTra",
    dataIndex: "bnChiTra",
    disabledCheck: true,
    width: 70,
    render: text => formatToCurrencyType(text),
    align: "right",
  },
  {
    title: "Hoàn trả BN",
    key: "tongTienHoanTra",
    dataIndex: "tongTienHoanTra",
    render: text => formatToCurrencyType(text),
    align: "right",
    width: 80,
  },

  {
    title: "Thực thu",
    key: "thucThu",
    dataIndex: "thucThu",
    disabledCheck: true,
    width: 70,
    render: text => formatToCurrencyType(text),
    align: "right",
  },
  {
    title: "TL miễn giảm bhyt",
    key: "tyLeMienGiam",
    dataIndex: "tyLeMienGiam",
    width: 80,
  },
];

export {revenuesFields, surgeryAllColums};
